import { InjectionToken } from '@angular/core';

export interface DiscoveryPageTool {
  name: string;
  description: string;
  inputSchema: object;
  annotations: { readOnlyHint: boolean; untrustedContentHint?: boolean };
  execute(input: object, options?: { signal?: AbortSignal }): Promise<unknown>;
}

export interface DiscoveryModelContext {
  registerTool(tool: DiscoveryPageTool, options?: { signal?: AbortSignal }): Promise<void> | void;
  unregisterTool?(name: string): void;
}

/** Native WebMCP only. Current browsers use Document; earlier implementations used Navigator. */
export const DISCOVERY_MODEL_CONTEXT = new InjectionToken<DiscoveryModelContext | null>(
  'Native discovery model context',
  {
    providedIn: 'root',
    factory: () => {
      const current =
        typeof document === 'undefined'
          ? null
          : (document as Document & { modelContext?: DiscoveryModelContext }).modelContext;
      const earlier =
        typeof navigator === 'undefined'
          ? null
          : (navigator as Navigator & { modelContext?: DiscoveryModelContext }).modelContext;
      if (typeof current?.registerTool === 'function') return current;
      return typeof earlier?.registerTool === 'function' ? earlier : null;
    },
  },
);
